import { __assign, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { usePopper } from 'react-popper';
import { border } from '@metro-ui/tokens/js';
import { InputGroupPropTypes, InputGroupsPropTypes } from './InputGroups';
import { DatePicker } from '../DatePicker';
import { Card } from '../Card';
import { OutsideClick } from '../utils';
/**
 * A basic component that is the boilerplate for both variants of
 * `InputGroupsWithDatePicker` (the one with and the one without range).
 * It mainly implements the `onOutsideClick` behavior and synchronizes the
 * date between the input fields and the DatePicker.
 */
export var InputGroupsWithDatePickerBasic = function (_a) {
    var DateInputs = _a.DateInputs, id = _a.id, groups = _a.groups, datePickerProps = _a.datePickerProps, inputGroupsProps = _a.inputGroupsProps;
    var _b = React.useState(false), isVisible = _b[0], setVisible = _b[1];
    var _c = React.useState(null), inputElement = _c[0], setInputElement = _c[1];
    var _d = React.useState(null), popperElement = _d[0], setPopperElement = _d[1];
    var _e = usePopper(inputElement, popperElement, {
        placement: 'bottom-start',
    }), styles = _e.styles, attributes = _e.attributes;
    return (React.createElement(OutsideClick, { onOutsideClick: function () { return setVisible(false); } }, function (_a) {
        var outsideClickRef = _a.outsideClickRef;
        return (React.createElement("div", { ref: outsideClickRef, style: {
                position: 'relative',
            } },
            React.createElement("div", { ref: setInputElement, style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                } },
                React.createElement(DateInputs, __assign({ id: id, setVisible: setVisible, groups: groups }, inputGroupsProps))),
            isVisible && (React.createElement("div", __assign({ ref: setPopperElement, style: __assign({ zIndex: 1 }, styles.popper) }, attributes.popper),
                React.createElement(Card, { style: { borderRadius: border.radius.large } },
                    React.createElement(DatePicker, __assign({}, datePickerProps, { id: id + "-date-picker", onClose: function () { return setVisible(false); } })))))));
    }));
};
export var InputGroupsWithDatePickerBasicPropTypes = {
    DateInputs: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    groups: PropTypes.arrayOf(PropTypes.shape(__assign({ dateRole: PropTypes.oneOf(['day', 'month', 'year']).isRequired }, InputGroupPropTypes))),
    inputGroupsProps: PropTypes.shape((function () {
        var id = InputGroupsPropTypes.id, value = InputGroupsPropTypes.value, groups = InputGroupsPropTypes.groups, onChange = InputGroupsPropTypes.onChange, ShortenedPropTypes = __rest(InputGroupsPropTypes, ["id", "value", "groups", "onChange"]);
        return __assign({}, ShortenedPropTypes);
    })()),
    datePickerProps: PropTypes.shape({
        id: PropTypes.string,
        onDayClick: PropTypes.func.isRequired,
        onClose: PropTypes.func,
        onCloseText: PropTypes.string,
        onClear: PropTypes.func,
        onClearText: PropTypes.string,
        monthLabel: PropTypes.string,
        yearLabel: PropTypes.string,
        title: PropTypes.string,
        className: PropTypes.string,
    }).isRequired,
};
InputGroupsWithDatePickerBasic.propTypes =
    InputGroupsWithDatePickerBasicPropTypes;
//# sourceMappingURL=InputGroupsWithDatePickerBasic.js.map